import { useTranslation } from "react-i18next";
import useUnAssignCourierToOrdersMutation from "./useUnAssignCourierToOrdersMutation";

const useUnassignHook = () => {
  const { t } = useTranslation("");
  const option = {
    name: t("unassignCourier"),
    item_id: -1,
  };
  const mutation = useUnAssignCourierToOrdersMutation();
  const onUnassign = (value, orders, cb?: Function) => {
    if (value === -1) {
      return mutation
        .mutateAsync({
          orders,
        })
        .then(() => {
          cb && cb();
        });
    }
  };
  return { ...mutation, option, onUnassign };
};

export default useUnassignHook;
